import React from 'react'
import homeimg1 from '../assets/homeimg1.png'
import { GiCheckMark } from 'react-icons/gi';
import '../css/Home.css'
import { Link } from 'react-router-dom';


const features = [
    {
        title: 'Industrial Water Purification',
        desc: 'Tailored solutions for industrial water treatment needs.',
    },
    {
        title: 'Domestic Water Purification',
        desc: 'Safe and reliable water purification for your home.',
    },
    {
        title: 'Commercial Water Purification',
        desc: 'Efficient water purification systems for commercial spaces.',
    },
    {
        title: 'Water Softener',
        desc: 'High-quality solutions for softening hard water.',
    },
    {
        title: 'DM Plant',
        desc: 'Advanced plants for producing high-quality demineralized water.',
    },
    {
        title: 'Wastewater Management',
        desc: 'Efficient systems for wastewater treatment and reuse.',
    },
];

const features2 = [
    "Industrial Water Purification",
    "Domestic Water Purification",
    "Commercial Water Purification",
    "Water Softener",
    "DM Plant",
    "Wastewater Management",
    // "Subscription Management",
    // "Analytics and Reporting",
]

const steps = [
    {
        number: 1,
        title: 'Schedule a Service',
        description: 'Book your water filter service easily through call or online. We offer flexible appointments that suit your daily schedule.'
    },
    {
        number: 2,
        title: 'Expert Diagnosis',
        description: 'Our skilled technicians inspect your system thoroughly, identify issues accurately, and explain the problem before beginning any necessary repairs.'
    },
    {
        number: 3,
        title: 'Efficient Repairs',
        description: 'We use quality parts and proven techniques to fix your water filter quickly, ensuring long-lasting performance and minimal future issues.'
    },
    {
        number: 4,
        title: 'Pure Performance',
        description: 'After service, enjoy consistently clean, safe water. Our maintenance helps improve system efficiency and prolongs the life of your filter.'
    }
]


const Home = () => {
    return (
        <>
            {/* =====================================top-section========================================= */}

            <section className='hero-section d-flex align-items-center py-5'>
                <div className='container'>
                    <div className='row align-items-center'>
                        {/* Left Text Content */}
                        <div className='col-lg-6 text-center text-lg-start mb-4 mb-lg-0'>
                            <h1 className='hero-title'>
                                SKYGUARD <br /><span className='gradient-text'>Repair and</span><br />Service.
                            </h1>
                            <p className='hero-subtext mt-4'>We ensure efficient water filter repair and service for clean, safe drinking water at your doorstep.</p>
                            <Link to='/contact'><button className='btn btn-custom bg-primary text-white px-4 py-2 mt-3'>Get Service</button></Link>
                        </div>

                        {/* Right Image and Product Card */}
                        <div className='col-lg-6 text-center position-relative'>
                            <img src={homeimg1} alt='' className='img-fluid main-image' />
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================Three-cards======================================= */}
            <section className='container mt-4'>
                <div className='row g-4 justify-content-center mt-5'>

                    {/* Card 1 */}
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className='dash-card gradient-background1 d-flex align-items-center justify-content-center text-center h-100 p-4'>
                            <h4 className='fw-semibold mb-0 text-white'>15+ Years Experience</h4>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className='dash-card gradient-background2 d-flex align-items-center justify-content-center text-center h-100 p-4'>
                            <h4 className='fw-semibold mb-0 text-white'>30 Expert Technicians</h4>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className='dash-card gradient-background3 d-flex align-items-center justify-content-center text-center h-100 p-4'>
                            <h4 className='fw-semibold mb-0 text-white'>100,000+ Satisfied Clients</h4>
                        </div>
                    </div>

                </div>
            </section>

            {/*======================================================= Feature-Section======================================== */}

            <section className='py-5 feature-section'>
                {/* heading */}
                <div className='text-left mb-5 mt-3'>
                    <h2 className='fw-bold text-dark'>
                        Our Services
                    </h2>
                    <p className='fw-medium'>We provide a wide range of services to meet your needs.</p>
                </div>

                <div className='row align-items-start g-2'>

                    {/* Left Column: 2 tick points */}
                    <div className='col-12 col-md-6 col-lg-4'>
                        {[0, 1, 2].map((idx) => (
                            <div key={idx} className='mb-4 d-flex align-items-start'>
                                <div className='check-icon me-3'><GiCheckMark /></div>
                                <div>
                                    <h5 className='fw-semibold'>{features[idx].title}</h5>
                                    <p className='text-muted'>{features[idx].desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='col-12 col-md-6 col-lg-4'>
                        {[3, 4, 5].map((idx) => (
                            <div key={idx} className='mb-4 d-flex align-items-start'>
                                <div className='check-icon me-3'><GiCheckMark /></div>
                                <div>
                                    <h5 className='fw-semibold'>{features[idx].title}</h5>
                                    <p className='text-muted'>{features[idx].desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    

                    {/* Right Column: Image */}
                    <div className='col-12 col-lg-4 text-center'>
                        <img src={homeimg1} alt='images here' className='img-fluid key-image' />
                    </div>

                </div>
            </section>

            {/* ===============================================feature-section===================================================== */}

            <section className='features-section text-white text-center py-5'>
                <div className='container'>
                    <h2 className='fw-bold mb-3'>Adaptable Features To Create Meaningful Connections</h2>
                    <p className='lead mb-5'>We’re on a mission to build lasting relationships between brands and people.</p>
                    
                    <div className='row justify-content-center'>
                        {features2.map((feature, idx) => (
                            <div key={idx} className='col-10 col-sm-6 col-md-4 col-lg-3 mb-3'>
                                <div className='feature-btn px-3 py-2'>{feature}</div>
                            </div>
                        ))}
                    </div>
                </div>

            </section>

            {/* =================================solution-section======================================= */}

            <section className='container py-5 sticky-section'>
                <div className='row align-items-center'>
                    {/* text */}
                    <div className='col-lg-6 col-md-12'>    
                        <h2 className='section-title'>Top Localities for RO-Water Purifier Service  </h2>
                        {/* <p className='section-desc'>With more than 15 years of experience developing ecommerce technology, our proprietary API-first billing optimization platform and subscription apps have helped thousands of merchants scale their businesses.</p> */}
                        
                        <div className='solution-links mt-3'>
                            <p className='solution-link'>Water Purifier Repair Service in Bhayander</p>
                            <p className='solution-link'>Water Purifier Repair Service in Sakinaka</p>
                            <p className='solution-link'> Water Purifier Repair Service in Churchgate</p>
                            <p className='solution-link'> Water Purifier Repair Service in Goregaon</p>
                            <p className='solution-link'>Water Purifier Repair Service in Thane</p>
                            <p className='solution-link'> Water Purifier Repair Service in Govandi</p>
                        </div>
                    </div>
                    {/* image */}
                    <div className='col-lg-6 col-md-12 text-center mt-4 mt-lg-0'>
                        <img src={homeimg1} alt="Sticky Cube" className="img-fluid cube-img" />
                    </div>
                </div>
            </section>

            {/* ======================================steps================================================= */}
            
            <section className='steps-section py-5'>
                <div className='container text-center'>
                    <h2 className='mb-5'>Follow Our 4-Step Process to <span className='text-success'>Profitability</span></h2>

                    <div className='row g-4'>
                        {steps.map((step) => (
                            <div key={step.number} className='col-12 col-sm-6 col-lg-3' >
                                <div className='step-card p-4 h-100 shadow-sm bg-secondary-subtle'>
                                    <div className='step-number mx-auto mb-3'>{step.number}</div>
                                    <h5 className='fw-bold'>{step.title}</h5>
                                    <p className='text-muted'>{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home